import { render, staticRenderFns } from "./AudioEdit.vue?vue&type=template&id=6aae06b1&scoped=true&"
import script from "./AudioEdit.vue?vue&type=script&lang=js&"
export * from "./AudioEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aae06b1",
  null
  
)

export default component.exports